<div class="current-pickup-section-wrapper">
  <!-- Customer Information -->
  <form [formGroup]="form">
    <ion-row class="current-pickup-address">
      <ion-col size="12">
        <ion-row>
          <ion-col size="12" class="section-header">
            {{ CONSTS.HEADER }}
          </ion-col>
        </ion-row>

        <ion-row>
          <!-- Customer Name -->
          <ion-col size="3.5">
            <div class="form-group">
              <app-form-text-field
                [labelText]="CONSTS.CUSTOMER_NAME"
                [form]="form"
                [control]="CONTROLS.CUSTOMER_NAME"
                [maxLength]="50"
                [biggerText]="true"
                [autoCapitalizeCharacters]="true"
              ></app-form-text-field>
            </div>
          </ion-col>

          <!-- Contact Name -->
          <ion-col size="3.5">
            <div class="form-group">
              <app-form-text-field
                [labelText]="CONSTS.CONTACT_NAME"
                [form]="form"
                [control]="CONTROLS.CONTACT_NAME"
                [hasRequiredSign]="false"
                [maxLength]="22"
                [biggerText]="true"
                [autoCapitalizeCharacters]="true"
              ></app-form-text-field>
            </div>
          </ion-col>

          <!-- Contact Number -->
          <ion-col size="3.5">
            <div class="form-group">
              <app-form-text-field
                [labelText]="CONSTS.CONTACT"
                [form]="form"
                [control]="CONTROLS.CONTACT"
                [hasRequiredSign]="false"
                [maxLength]="25"
                [biggerText]="true"
                [autoCapitalizeCharacters]="true"
              ></app-form-text-field>
            </div>
          </ion-col>
        </ion-row>

        <ion-row>
          <!-- Street Address -->
          <ion-col size="2">
            <div class="form-group">
              <app-form-text-field
                [labelText]="CONSTS.STREET_ADDRESS"
                [form]="form"
                [control]="CONTROLS.STREET_ADDRESS"
                [hasRequiredSign]="false"
                [maxLength]="11"
                [biggerText]="true"
                [autoCapitalizeCharacters]="true"
              ></app-form-text-field>
            </div>
          </ion-col>

          <!-- Prefix -->
          <ion-col size="1">
            <div class="form-group">
              <app-form-text-field
                [labelText]="CONSTS.PREFIX"
                [form]="form"
                [control]="CONTROLS.PREFIX"
                [hasRequiredSign]="false"
                [maxLength]="2"
                [biggerText]="true"
                [autoCapitalizeCharacters]="true"
              ></app-form-text-field>
            </div>
          </ion-col>

          <!-- Street Name -->
          <ion-col size="3.5">
            <div class="form-group">
              <app-form-text-field
                [labelText]="CONSTS.STREET_NAME"
                [form]="form"
                [control]="CONTROLS.STREET_NAME"
                [maxLength]="50"
                [biggerText]="true"
                [autoCapitalizeCharacters]="true"
              ></app-form-text-field>
            </div>
          </ion-col>

          <!-- Suffix -->
          <ion-col size="1">
            <div class="form-group">
              <app-form-text-field
                [labelText]="CONSTS.SUFFIX"
                [form]="form"
                [control]="CONTROLS.SUFFIX"
                [hasRequiredSign]="false"
                [maxLength]="2"
                [biggerText]="true"
                [autoCapitalizeCharacters]="true"
              ></app-form-text-field>
            </div>
          </ion-col>

          <!-- Street Type -->
          <ion-col size="1.5">
            <div class="form-group">
              <app-form-text-field
                [labelText]="CONSTS.STREET_TYPE"
                [form]="form"
                [control]="CONTROLS.STREET_TYPE"
                [hasRequiredSign]="false"
                [maxLength]="4"
                [biggerText]="true"
                [autoCapitalizeCharacters]="true"
              ></app-form-text-field>
            </div>
          </ion-col>

          <!-- Suite -->
          <ion-col size="1">
            <div class="form-group">
              <app-form-text-field
                [labelText]="CONSTS.SUITE"
                [form]="form"
                [control]="CONTROLS.SUITE"
                [hasRequiredSign]="false"
                [maxLength]="8"
                [biggerText]="true"
                [autoCapitalizeCharacters]="true"
              ></app-form-text-field>
            </div>
          </ion-col>

          <!-- Floor -->
          <ion-col size="2">
            <div class="form-group">
              <app-form-text-field
                [labelText]="CONSTS.FLOOR"
                [form]="form"
                [control]="CONTROLS.FLOOR"
                [hasRequiredSign]="false"
                [maxLength]="3"
                [biggerText]="true"
                [autoCapitalizeCharacters]="true"
              ></app-form-text-field>
            </div>
          </ion-col>
        </ion-row>

        <ion-row>
          <!-- City -->
          <ion-col size="3">
            <div class="form-group">
              <app-form-text-field
                [labelText]="CONSTS.CITY_TOWN"
                [form]="form"
                [control]="CONTROLS.CITY_TOWN"
                [hasRequiredSign]="false"
                [maxLength]="50"
                [biggerText]="true"
                [autoCapitalizeCharacters]="true"
              ></app-form-text-field>
            </div>
          </ion-col>

          <!-- Province -->
          <ion-col size="1.5">
            <div class="form-group">
              <app-form-text-field
                [labelText]="CONSTS.PROVINCE"
                [form]="form"
                [control]="CONTROLS.PROVINCE"
                [maxLength]="2"
                [minLength]="2"
                [biggerText]="true"
                [autoCapitalizeCharacters]="true"
              ></app-form-text-field>
            </div>
          </ion-col>

          <!-- Postal Code -->
          <ion-col size="2.5">
            <div class="form-group">
              <app-form-text-field
                [labelText]="CONSTS.POSTAL_CODE"
                [maxLength]="8"
                [form]="form"
                [control]="CONTROLS.POSTAL_CODE"
                [biggerText]="true"
                [autoCapitalizeCharacters]="true"
              ></app-form-text-field>
              @if (
                form.get("postalCode")?.invalid &&
                form.get("postalCode")?.errors?.["nonCanadianPostal"]
              ) {
                <div class="required-field">
                  {{ CONSTS.CANADIAN_POSTAL_ERROR }}
                </div>
              }
            </div>
          </ion-col>

          <!-- Latitude -->
          <ion-col size="2.5">
            <div class="form-group">
              <app-form-text-field
                [labelText]="CONSTS.LATITUDE"
                [form]="form"
                [regexType]="REGEX_LATLONG"
                [control]="CONTROLS.LATITUDE"
                [hasRequiredSign]="false"
                [readonly]="true"
                [biggerText]="true"
                [autoCapitalizeCharacters]="true"
              ></app-form-text-field>
            </div>
          </ion-col>

          <!-- Longitude -->
          <ion-col size="2.5">
            <app-form-text-field
              [labelText]="CONSTS.LONGITUDE"
              [form]="form"
              [regexType]="REGEX_LATLONG"
              [control]="CONTROLS.LONGITUDE"
              [hasRequiredSign]="false"
              [readonly]="true"
              [biggerText]="true"
              [autoCapitalizeCharacters]="true"
            ></app-form-text-field>
          </ion-col>
        </ion-row>

        <!-- Validate -->
        <ion-row class="validate-row">
          @if (validationCode === "-5") {
            <span class="validate-error-text">
              {{ CONSTS.VALIDATION_FAILED_NULL_SITE_ID }}
            </span>
          }
          @if (validationCode === "-4") {
            <span class="validate-error-text">
              {{ CONSTS.VALIDATION_FAILED_REQUEST_ID }}
            </span>
          }
          @if (validationCode === "-3") {
            <span class="validate-error-text">
              {{ CONSTS.VALIDATION_FAILED_INPUT_ADDRESS }}
            </span>
          }
          @if (validationCode === "-2") {
            <span class="validate-error-text">
              {{ CONSTS.VALIDATION_FAILED_AAA_UNAVAILABLE }}
            </span>
          }
          @if (validationCode === "-1") {
            <span class="validate-error-text">
              {{ CONSTS.VALIDATION_FAILED_SOURCE_INVALID }}
            </span>
          }
          @if (validationCode === "0" && !validatedLngNr && !validatedLatNr) {
            <span class="validate-error-text">
              {{ CONSTS.VALIDATION_FAILED_NO_LATLONG }}
            </span>
          }
          @if (validationCode === "0" && validatedLngNr && validatedLatNr) {
            <span class="validate-success-text">
              {{ CONSTS.VALIDATION_SUCCEEDED }}
            </span>
          }

          <ion-button
            fill="fill"
            onkeypress="validate()"
            class="validate-button"
            [ngClass]="{
              'is-disabled': this.form.invalid || this.form.pristine,
            }"
            [disabled]="this.form.invalid || this.form.pristine"
            (click)="validate()"
            >{{ CONSTS.VALIDATE }}</ion-button
          >
        </ion-row>
      </ion-col>

      <ion-col size="12">
        <ion-radio-group
          [allowEmptySelection]="true"
          (ionChange)="onItemChange($event)"
          class="radio-group"
          #radioGroup
        >
          <div
            class="address-wrapper"
            [ngClass]="{ 'focus-border': activeAddress === 'original' }"
          >
            <ion-item lines="none">
              <ion-label>{{ CONSTS.ORIGINAL_ADDRESS }}</ion-label>
            </ion-item>
            <app-address-section
              [data]="originalAddressData"
              [form]="form"
            ></app-address-section>
          </div>

          <div
            class="address-wrapper"
            [ngClass]="{ 'focus-border': activeAddress === 'parsed' }"
          >
            <ion-item lines="none">
              <ion-label>{{ CONSTS.PARSED_ADDRESS }}</ion-label>
            </ion-item>
            <app-address-section
              [data]="parsedAAAAddressData"
              [form]="form"
            ></app-address-section>
          </div>
        </ion-radio-group>
      </ion-col>
    </ion-row>
  </form>
</div>
